import { combineReducers } from 'redux';

import loginReducer from './reducers/loginReducer';

import Login from './containers/Login';
import ForgotPasswordContainer from './containers/ForgotPasswordContainer';
import ResetPasswordContainer from './containers/ResetPasswordContainer';

import userActionV2 from './actions/userActionsV2'

const reducers = combineReducers({
    userData: loginReducer,
});

const components = { Login, ForgotPasswordContainer, ResetPasswordContainer };

const actions = { userActionV2 }

export { components, reducers, actions };